import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_ORDERS: MijnRoute = {
    path: ':id/orders',
    navigationEvent: 'toOrders',
    regex: /^\/beleggen\/[^/]+\/orders$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/orders'
};
